import { getTranslatedText } from '@nile/components';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

// Helpers for generating custom fields columns
export const getValidators = (customField) => {
  switch (customField.fieldType) {
    case 'NUMERIC':
      return [
        {
          validate: 'regex_match',
          regex: '^[+-]?[0-9]+$',
          errorMessage: 'dromo.validation.numeric'
        }
      ];
    case 'DECIMAL':
      return [
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: "^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$",
          errorMessage: 'dromo.validation.decimal'
        }
      ];
    case 'DATE':
      return [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])(Z)?$',
          errorMessage: 'dromo.validation.date'
        }
      ];
    case 'DATETIME':
      return [
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        }
      ];
    default:
      return [];
  }
};

export const getFieldType = (customField) => {
  switch (customField.fieldType) {
    case 'SELECT':
    case 'RADIO':
      return 'select';
    default:
      return 'string';
  }
};

export const getSelectOptions = (customField, isallFields = false) => {
  switch (customField.fieldType) {
    case 'SELECT':
    case 'RADIO':
    case 'CHECKBOX':
    case 'MULTI_SELECT':
      return customField.options?.map((option) => ({
        value: isallFields ? option.value : option,
        label: isallFields ? option.value : option
      }));
    default:
      return [];
  }
};

export const getFieldDescription = (intl, customField, isallFields = false) => {
  switch (customField.fieldType) {
    case 'CHECKBOX':
    case 'MULTI_SELECT':
      return getTranslatedText(intl, 'dromo.description.multiSelect', {
        fieldOptions: isallFields
          ? customField.options.map((opt) => opt.value).join(', ')
          : customField.options.join(', ')
      });
    default:
      return null;
  }
};

export const isMultiSelect = (customField) => {
  switch (customField.fieldType) {
    case 'CHECKBOX':
    case 'MULTI_SELECT':
      return true;
    default:
      return false;
  }
};

// Utils
export const splitter = (string, delimiter = ';') =>
  string
    ?.split(delimiter)
    ?.map((string) => string?.trim())
    ?.filter((string) => !!string);

export const duplicateChecker = (array, caseInsensitive) => {
  const duplicateCheckerMap = {};
  for (let i = 0; i < array.length; i++) {
    const ele = caseInsensitive ? array[i].toLowerCase() : array[i];
    if (duplicateCheckerMap[ele]) {
      return true;
    }
    duplicateCheckerMap[ele] = true;
  }
  return false;
};

export const intlConverter = (intl, fields) => {
  const copyOfFields = [...fields];
  fields.forEach((field, fieldIdx) => {
    copyOfFields[fieldIdx].label = getTranslatedText(intl, field.label);
    if (field.selectOptions && field.selectOptions.length) {
      field.selectOptions.forEach((option, optionIdx) => {
        copyOfFields[fieldIdx].selectOptions[optionIdx].label = isEmpty(
          option.label
        )
          ? option.label
          : getTranslatedText(intl, option.label);
      });
    }
    if (field.validators) {
      field.validators.forEach((validator, validatorIdx) => {
        const i18nKey = validator.errorMessage;
        copyOfFields[fieldIdx].validators[
          validatorIdx
        ].errorMessage = getTranslatedText(intl, i18nKey);
      });
    }
  });
  return copyOfFields;
};
